import React from "react"
import { graphql } from 'gatsby'


import Layout from "../components/layout"
import SEO from "../components/seo"
import HeroSection from "../components/Reuseable/HeroSection"
import InfoBlock from "../components/Reuseable/infoblock"
import Productcart from "../components/Cart/Productcart"
import DualInfoBlock from "../components/Reuseable/DualInfoblock"

const IndexPage = ({data}) => (
  <Layout>
    <SEO title="Home" />
    
    <HeroSection
      
      title = ""
      subtitle =  ""
      heroclass = "hero-background"
      />
      
    <Productcart products={data.products}/>
    <DualInfoBlock heading="Information"/>
    <InfoBlock  heading="About Us"/>
    
    
  </Layout>
)

export const query = graphql`
{
 img: file(relativePath: { eq: "heromain.png" }) {
          childImageSharp {
            fluid(quality: 90, maxWidth: 1920) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
        products:allContentfulProducts{
    edges{
      node{
        id
        title
        price
        category
        description{
          description
        }
        image{
          fixed(width:200, height:120){
            ...GatsbyContentfulFixed_tracedSVG

          }
        }
      }
    }
  }
      }

`

export default IndexPage
